window.theme = window.theme || {};

window.theme.sizes = {
  mobile: 480,
  small: 750,
  large: 990,
  widescreen: 1400,
};

window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
